import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '../ui/alert-dialog';
import { Loader2, Trash2, AlertTriangle } from 'lucide-react';

/**
 * Danger zone component - Delete all data functionality
 */
export const DangerZone = ({ deleteLoading, onDeleteAllData }) => {
  return (
    <Card className="mt-6 border-red-200 bg-red-50/30">
      <CardHeader>
        <CardTitle className="font-serif text-lg text-red-700 flex items-center gap-2">
          <AlertTriangle className="w-5 h-5" />
          Danger Zone
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-red-600/80 mb-4">
          This action will permanently delete all users (except admin), transactions, vouchers, and sub-admins. This cannot be undone.
        </p>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button 
              variant="destructive" 
              className="w-full bg-red-600 hover:bg-red-700"
              disabled={deleteLoading}
            >
              {deleteLoading ? (
                <Loader2 className="w-4 h-4 animate-spin mr-2" />
              ) : (
                <Trash2 className="w-4 h-4 mr-2" />
              )}
              Delete All Data
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle className="text-red-700">Are you absolutely sure?</AlertDialogTitle>
              <AlertDialogDescription>
                This action cannot be undone. This will permanently delete:
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>All user accounts (except admin)</li>
                  <li>All transactions</li>
                  <li>All vouchers</li>
                  <li>All sub-admins</li>
                  <li>All session data</li>
                </ul>
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction 
                onClick={onDeleteAllData}
                className="bg-red-600 hover:bg-red-700"
              >
                Yes, Delete Everything
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </CardContent>
    </Card>
  );
};

export default DangerZone;
